import type {Moment} from 'moment';

import type {
  CalendarEntry,
  CalendarFilesByDate,
  CalendarProcessTasksByDate,
  CalendarView,
} from 'calendar/CalendarConstants';
import type {EmptyPayload} from 'constants/events/EventPayloadUtils';
import type {Request} from 'requests/RequestConstants';

type CalendarEntryFromServer = Omit<CalendarEntry, 'date'> & {date: string};

interface CalendarEntriesFetchResponse {
  [dateString: string]: Array<CalendarEntryFromServer>;
}

interface CalendarRequestsFetchResponse {
  [dateString: string]: Array<Request>;
}

export const CALENDAR_EVENT_PAYLOADS = {
  CALENDAR_CLOSE_CREATE_POPOVER: {} as EmptyPayload,
  CALENDAR_DATE_NAVIGATE: {} as {visibleDate: Moment},
  CALENDAR_DAY_MOUSE_DOWN: {} as {date: Moment},
  CALENDAR_DAY_MOUSE_OVER: {} as {date: Moment},
  CALENDAR_DAY_MOUSE_UP: {} as {x: number; y: number},
  CALENDAR_ENTRIES_FETCH: {} as EmptyPayload,
  CALENDAR_ENTRIES_FETCH_COMPLETED: {} as {entries: CalendarEntriesFetchResponse},
  CALENDAR_ENTRIES_FETCH_FAILED: {} as EmptyPayload,
  CALENDAR_FILES_FETCH: {} as EmptyPayload,
  CALENDAR_FILES_FETCH_COMPLETED: {} as {files: CalendarFilesByDate},
  CALENDAR_FILES_FETCH_FAILED: {} as EmptyPayload,
  CALENDAR_REQUESTS_FETCH: {} as EmptyPayload,
  CALENDAR_REQUESTS_FETCH_COMPLETED: {} as {requests: CalendarRequestsFetchResponse},
  CALENDAR_REQUESTS_FETCH_FAILED: {} as EmptyPayload,
  CALENDAR_PROCESS_TASKS_FETCH: {} as EmptyPayload,
  CALENDAR_PROCESS_TASKS_FETCH_COMPLETED: {} as {processTasks: CalendarProcessTasksByDate},
  CALENDAR_PROCESS_TASKS_FETCH_FAILED: {} as EmptyPayload,
  CALENDAR_ITEM_DESELECTED: {} as EmptyPayload,
  CALENDAR_ITEM_SELECTED: {} as {itemId: string; date: Moment},
  CALENDAR_TOGGLE_PROJECT_HIDDEN: {} as {projectId: string},
  CALENDAR_UPDATE_ENTRY_TASK: {} as {
    date: Moment;
    entryId: string;
    notePartProvenanceId: number;
    completed: boolean;
  },
  CALENDAR_UPDATE_FILTERED_MEMBERS: {} as {memberIds: Array<string>; shouldHide: boolean},
  CALENDAR_UPDATE_TODAY: {} as EmptyPayload,
  CALENDAR_VIEW_CHANGE: {} as {view: CalendarView},
} as const;

export type CalendarEventPayload = typeof CALENDAR_EVENT_PAYLOADS;
